import createCache from "@emotion/cache";
import { IconlyProvider } from "react-iconly";
import { RouterProvider } from "react-router-dom";
import "src/assets/fonts/index.css";
import { prefixer } from "stylis";
import stylisRTLPlugin from "stylis-plugin-rtl";

import Routers from "./pages/routepage";
import { CacheProvider } from "@emotion/react";
import { MenuProvider } from "./contexts/menu-context/MenuContext";
import { AppThemeContextProvider } from "./contexts/them-context/ThemContext";
import { ApolloClientProvider, NotistackProvider, ThemeProvider } from "./config/Config";
import { UserProvider } from "./contexts/UserContext";
import { Suspense } from "react";

// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, stylisRTLPlugin],
});

function App() {
  return (
    <AppThemeContextProvider>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider>
          <UserProvider>
            <MenuProvider>
              <NotistackProvider>
                <ApolloClientProvider>
                  <IconlyProvider>
                    <Suspense fallback={<div />}>
                      <RouterProvider router={Routers} />
                    </Suspense>
                  </IconlyProvider>
                </ApolloClientProvider>
              </NotistackProvider>
            </MenuProvider>
          </UserProvider>
        </ThemeProvider>
      </CacheProvider>
    </AppThemeContextProvider>
  );
}

export default App;
